import React from 'react';
import cn from 'classnames';

import styles from './DetailsWrapper.module.sass';

export type DetailsWrapperProps = {
  className?: string;
  children?: React.ReactNode;
};

function DetailsWrapper({children, className}: DetailsWrapperProps) {
  return <div className={cn(styles.wrapper, className)}>{children}</div>;
}

export {DetailsWrapper};
